import * as ambassadorWixPremiumDomainsV1ConnectedDomain from './premium-domains-v1-connected-domain-connected-domains.http.js';
import * as ambassadorWixPremiumDomainsV1ConnectedDomainTypes from './premium-domains-v1-connected-domain-connected-domains.types.js';
import * as ambassadorWixPremiumDomainsV1ConnectedDomainUniversalTypes from './premium-domains-v1-connected-domain-connected-domains.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createConnectedDomain(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPremiumDomainsV1ConnectedDomainUniversalTypes.CreateConnectedDomainRequest,
  ambassadorWixPremiumDomainsV1ConnectedDomainTypes.CreateConnectedDomainRequest,
  ambassadorWixPremiumDomainsV1ConnectedDomainUniversalTypes.CreateConnectedDomainResponse,
  ambassadorWixPremiumDomainsV1ConnectedDomainTypes.CreateConnectedDomainResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPremiumDomainsV1ConnectedDomain.createConnectedDomain(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/connected-domains',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getConnectedDomain(): __PublicMethodMetaInfo<
  'GET',
  { connectedDomainId: string },
  ambassadorWixPremiumDomainsV1ConnectedDomainUniversalTypes.GetConnectedDomainRequest,
  ambassadorWixPremiumDomainsV1ConnectedDomainTypes.GetConnectedDomainRequest,
  ambassadorWixPremiumDomainsV1ConnectedDomainUniversalTypes.GetConnectedDomainResponse,
  ambassadorWixPremiumDomainsV1ConnectedDomainTypes.GetConnectedDomainResponse
> {
  const payload = { connectedDomainId: ':connectedDomainId' } as any;

  const getRequestOptions =
    ambassadorWixPremiumDomainsV1ConnectedDomain.getConnectedDomain(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/connected-domains/{connectedDomainId}',
    pathParams: { connectedDomainId: 'connectedDomainId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteConnectedDomain(): __PublicMethodMetaInfo<
  'DELETE',
  { connectedDomainId: string },
  ambassadorWixPremiumDomainsV1ConnectedDomainUniversalTypes.DeleteConnectedDomainRequest,
  ambassadorWixPremiumDomainsV1ConnectedDomainTypes.DeleteConnectedDomainRequest,
  ambassadorWixPremiumDomainsV1ConnectedDomainUniversalTypes.DeleteConnectedDomainResponse,
  ambassadorWixPremiumDomainsV1ConnectedDomainTypes.DeleteConnectedDomainResponse
> {
  const payload = { connectedDomainId: ':connectedDomainId' } as any;

  const getRequestOptions =
    ambassadorWixPremiumDomainsV1ConnectedDomain.deleteConnectedDomain(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/connected-domains/{connectedDomainId}',
    pathParams: { connectedDomainId: 'connectedDomainId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listConnectedDomains(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPremiumDomainsV1ConnectedDomainUniversalTypes.ListConnectedDomainsRequest,
  ambassadorWixPremiumDomainsV1ConnectedDomainTypes.ListConnectedDomainsRequest,
  ambassadorWixPremiumDomainsV1ConnectedDomainUniversalTypes.ListConnectedDomainsResponse,
  ambassadorWixPremiumDomainsV1ConnectedDomainTypes.ListConnectedDomainsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPremiumDomainsV1ConnectedDomain.listConnectedDomains(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/connected-domains',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  ConnectedDomain as ConnectedDomainOriginal,
  ConnectionType as ConnectionTypeOriginal,
  ConnectionTypeWithLiterals as ConnectionTypeWithLiteralsOriginal,
  SiteInfo as SiteInfoOriginal,
  SiteInfoAssignmentInfoOneOf as SiteInfoAssignmentInfoOneOfOriginal,
  AssignmentType as AssignmentTypeOriginal,
  AssignmentTypeWithLiterals as AssignmentTypeWithLiteralsOriginal,
  RedirectAssignmentInfo as RedirectAssignmentInfoOriginal,
  DnsPropagationStatus as DnsPropagationStatusOriginal,
  DnsPropagationStatusWithLiterals as DnsPropagationStatusWithLiteralsOriginal,
  CreateConnectedDomainRequest as CreateConnectedDomainRequestOriginal,
  CreateConnectedDomainResponse as CreateConnectedDomainResponseOriginal,
  GetConnectedDomainRequest as GetConnectedDomainRequestOriginal,
  GetConnectedDomainResponse as GetConnectedDomainResponseOriginal,
  DeleteConnectedDomainRequest as DeleteConnectedDomainRequestOriginal,
  DeleteConnectedDomainResponse as DeleteConnectedDomainResponseOriginal,
  ListConnectedDomainsRequest as ListConnectedDomainsRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ListConnectedDomainsResponse as ListConnectedDomainsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './premium-domains-v1-connected-domain-connected-domains.types.js';
